export default __webpack_public_path__ + "static/media/Info.df517275.png";